import { useEffect, useState } from "react";

import { getViewing, returnToMyAccount } from "@/api/admin";

// ADM-2 — shown on every screen while a staff member is viewing someone else's account.
// One click ends the pass and brings them back to the Admin screen as themselves.

const minutesLeft = (until: number) => Math.max(0, Math.ceil((until - Date.now()) / 60000));

export const AdminBanner = () => {
  const [viewing, setViewing] = useState(getViewing());
  const [, tick] = useState(0);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const t = setInterval(() => {
      setViewing(getViewing());
      tick((n) => n + 1);
    }, 30000);
    return () => clearInterval(t);
  }, []);

  if (!viewing) return null;

  const left = minutesLeft(viewing.until);
  const leave = async () => {
    setLeaving(true);
    await returnToMyAccount();
    window.location.href = "/admin";
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-[9999] flex flex-wrap items-center justify-center gap-x-4 gap-y-1 bg-amber-400 px-4 py-2 text-sm text-amber-950 shadow-lg">
      <span>
        Viewing as <strong>{viewing.name}</strong>
        {viewing.company ? ` (${viewing.company})` : ""} · {viewing.email}
        {left > 0 ? ` · ${left} min left` : " · this visit has ended"}
      </span>
      <button onClick={leave} disabled={leaving} className="rounded-md bg-amber-950 px-3 py-1 text-xs font-semibold text-white hover:bg-black disabled:opacity-60">
        {leaving ? "Returning…" : "Return to my account"}
      </button>
    </div>
  );
};
